import React, { useEffect, useMemo, useState } from "react";
import { Container, Row, Col, Card, CardBody, Button } from "reactstrap";
import { formContentContainer, loaderOverlay } from "../../Style/loaderOverly";
import { AvForm } from "availity-reactstrap-validation";
import { Link, useNavigate, useParams } from "react-router-dom";
import { createPageData, invoiceFormData } from "./InvoiceFile";
import { LoaderCreatePage } from "../Loader/Loader";
import {
  DownloadPDFData,
  formatDate,
  formatNumber,
  getRecords,
} from "../../services/api.service";
import UserDetailsModal from "../../components/CommonForBoth/TopbarDropdown/UserProfile/UserDetailModel";
import InvoicePDF from "./InvoicePDF/InvoicePDF";

const InvoiceView = () => {
  const breadcrumbItems = [];
  const { id } = useParams();
  const navigate = useNavigate();

  const { payload, navigatePage, headerName, getEndpoint, stageOptions } =
    createPageData();
  const initialPayload = useMemo(() => payload, []);
  const [loadingData, setLoadingData] = useState(id ? true : false);
  const [formData, setFormData] = useState(invoiceFormData());
  const [fetchedData, setFetchedData] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [isWarehouseModalOpen, setIsWarehouseModalOpen] = useState(false);
  const [expandedRows, setExpandedRows] = useState({});

  useEffect(() => {
    if (id) {
      getEditData(id);
    }
  }, [id]);

  useEffect(() => {
    if (fetchedData) {
      let data = fetchedData;
      setFormData((prevState) => ({
        ...prevState,
        inputData: {
          ...prevState.inputData,
          ...data,
        },
      }));
    }
  }, [fetchedData]);

  const getEditData = async (id) => {
    try {
      let payload = {
        modelName: "invoices",
        modifyResponse: true,
        getBuyItemObjectOfInvoice: true,
        whereCondition: {
          id: id,
        },
        relations: [
          {
            module: "invoice_order_items",
            moduleAs: "invoice_order_items",
            subModule: "item_masters",
            subModuleAs: "item",
            subSubModule: "uom_masters",
            subSubModuleAs: "uom",
          },
          {
            module: "projects",
            moduleAs: "project",
          },
          {
            module: "orders",
            moduleAs: "order",
          },
          {
            module: "warehouse_masters",
            moduleAs: "warehouse",
          },
        ],
      };
      const responseData = await getRecords(payload, getEndpoint);

      if (responseData?.code == 1 && responseData.data.length > 0) {
        const data = responseData.data[0];
        setFetchedData(data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingData(false);
    }
  };

  // Filter items based on search query
  const filteredItems =
    formData?.inputData?.invoice_order_items?.filter((item) =>
      item?.item?.item_code.toLowerCase().includes(searchQuery.toLowerCase())
    ) || [];

  // Calculate totals for the columns
  const totalQty =
    filteredItems &&
    filteredItems?.reduce(
      (acc, item) => acc + (parseFloat(item?.order_qty) || 0),
      0
    );

  const totalInvoiceQty =
    filteredItems &&
    filteredItems?.reduce(
      (acc, item) => acc + (parseFloat(item?.invoice_qty) || 0),
      0
    );

  const totalUnitRate =
    filteredItems &&
    filteredItems?.reduce(
      (acc, item) => acc + (parseFloat(item?.unit_rate) || 0),
      0
    );

  const totalAmountData =
    filteredItems &&
    filteredItems?.reduce(
      (acc, item) =>
        acc +
        (parseFloat(item?.amount) ||
          parseFloat(item?.unit_rate) * parseFloat(item?.qty)),
      0
    );

  const toggleRow = (index) => {
    setExpandedRows((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const FloatValue = (value) => {
    return parseFloat(value).toFixed(3);
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Row>
            <Col xl="12">
              <Card>
                <CardBody>
                  <div style={formContentContainer}>
                    <AvForm className="needs-validation">
                      <div className="card mt-4">
                        <div className="card-header">
                          <h5>Invoice Details</h5>

                          <Button
                            style={{ marginLeft: "10px" }}
                            color="secondary"
                            className="waves-effect waves-light me-1 back-button"
                            onClick={() => navigate(navigatePage?.back)}
                          >
                            Back
                          </Button>
                          <Button
                            color="success"
                            className="waves-effect waves-light me-1 back-button ml-2"
                            style={{ borderRadius: "50%" }}
                            onClick={() =>
                              DownloadPDFData("InvoiceDetails.pdf")
                            }
                          >
                            <i class="fas fa-download"></i>
                          </Button>
                        </div>
                        <div className="card-body">
                          <Row className="mb-4">
                            {/* Section 1: Project & Order Information */}
                            <Col
                              md="4"
                              className="border-end border-secondary p-3"
                            >
                              <p>
                                <strong>Project: </strong>
                                {formData?.inputData?.project?.project_name ? (
                                  <span
                                    className="text-primary hover-pointer"
                                    onClick={() =>
                                      navigate(
                                        `/project-view/${
                                          formData?.inputData?.project_id ||
                                          formData?.inputData?.project?.id
                                        }`
                                      )
                                    }
                                    style={{ cursor: "pointer" }}
                                  >
                                    {formData?.inputData?.project?.project_name}
                                  </span>
                                ) : (
                                  "-"
                                )}
                              </p>
                              <p>
                                <strong>Project Code: </strong>
                                {formData?.inputData?.project?.project_code ? (
                                  <span>
                                    {formData?.inputData?.project?.project_code}
                                  </span>
                                ) : (
                                  "-"
                                )}
                              </p>
                              <p>
                                <strong>SO No: </strong>
                                {formData?.inputData?.order?.order_no ? (
                                  <span
                                    className="text-primary hover-pointer"
                                    onClick={() =>
                                      navigate(
                                        `/order-view/${
                                          formData?.inputData?.order_id ||
                                          formData?.inputData?.order?.id
                                        }`
                                      )
                                    }
                                    style={{ cursor: "pointer" }}
                                  >
                                    {formData?.inputData?.order?.order_no}
                                  </span>
                                ) : (
                                  "-"
                                )}
                              </p>
                              <p>
                                <strong>Invoice No: </strong>
                                {formData?.inputData?.invoice_no || "-"}
                              </p>
                            </Col>

                            {/* Section 2: Dates & Timeline */}
                            <Col
                              md="4"
                              className="border-end border-secondary p-3"
                            >
                              <p>
                                <strong>Warehouse: </strong>
                                <span
                                  className="text-primary cursor-pointer"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => setIsWarehouseModalOpen(true)}
                                >
                                  {formData?.inputData?.warehouse
                                    ?.warehouse_name || "-"}
                                </span>
                              </p>

                              {isWarehouseModalOpen && (
                                <UserDetailsModal
                                  onClose={() => setIsWarehouseModalOpen(false)}
                                  id={formData?.inputData?.warehouse?.id}
                                  type="warehouse"
                                />
                              )}
                              <p>
                                <strong>Invoice Date: </strong>
                                {formatDate(formData?.inputData?.createdAt) ||
                                  "-"}
                              </p>

                              <p>
                                <strong>Order Date: </strong>
                                {formatDate(
                                  formData?.inputData?.order?.order_date
                                ) || "-"}
                              </p>
                              <p>
                                <strong>Invoice Status: </strong>
                                {formData?.inputData?.status
                                  ?.split("_")
                                  .join(" ")
                                  .toUpperCase()}
                              </p>
                            </Col>

                            {/* Section 3: Additional Details */}
                            <Col md="4" className="p-3">
                              <p>
                                <strong>Address: </strong>
                                {formData?.inputData?.order?.address || "-"}
                              </p>
                              <p>
                                <strong>Remark: </strong>
                                {formData?.inputData?.remark || "-"}
                              </p>
                              <p>
                                <strong>Status </strong>
                                {formData?.inputData?.is_active
                                  ? "ACTIVE"
                                  : "IN-ACTIVE" || "-"}
                              </p>
                            </Col>
                          </Row>
                        </div>
                      </div>

                      <Row className="mt-4">
                        <div className="item-list-container">
                          <div className="d-flex justify-content-between align-items-center">
                            <h6 className="h-6-heading">Invoice Order Items</h6>

                            <div className="app-search d-flex d-lg-inline mt-0 p-0">
                              <div className="position-relative">
                                <input
                                  type="text"
                                  className="form-control ps-5"
                                  placeholder="Search by item code..."
                                  value={searchQuery}
                                  onChange={(e) =>
                                    setSearchQuery(e.target.value)
                                  }
                                  style={{
                                    width: "13rem",
                                    padding: "8px 15px",
                                    borderRadius: "8px",
                                    borderColor: "#D2D2D2",
                                    outline: "none",
                                    transition: "all 0.3s ease",
                                    boxShadow: "none",
                                    marginRight: "0.5rem",
                                  }}
                                />
                                <span className="ri-search-line"></span>
                              </div>
                            </div>
                          </div>

                          <div
                            className="table mt-2"
                            style={{
                              // overflow: "auto",
                              overflowX: "auto",
                              overflowY: "auto",
                              maxHeight: "500px",
                              width: "100%",
                              scrollBehavior: "smooth",
                              scrollbarWidth: "thin",
                              msOverflowStyle: "none",
                              zIndex: 0,
                            }}
                          >
                            <table className="table table-hover">
                              <thead
                                style={{
                                  backgroundColor: "#8AC1E8",
                                  position: "sticky",
                                  top: 0,
                                  backgroundColor: "#8AC1E8",
                                  borderBottom: "1px solid black",
                                }}
                              >
                                <tr>
                                  <th style={{ whiteSpace: "nowrap" }}>
                                    Sr. No
                                  </th>
                                  <th style={{ whiteSpace: "nowrap" }}>
                                    Item Code
                                  </th>
                                  <th style={{ whiteSpace: "nowrap" }}>
                                    Item Description
                                  </th>
                                  <th style={{ whiteSpace: "nowrap" }}>
                                    {" "}
                                    Customer Desc
                                  </th>
                                  <th style={{ whiteSpace: "nowrap" }}>UOM</th>
                                  <th style={{ whiteSpace: "nowrap" }}>
                                    {" "}
                                    Order QTY
                                  </th>
                                  <th style={{ whiteSpace: "nowrap" }}>
                                    Invoice QTY
                                  </th>
                                  <th style={{ whiteSpace: "nowrap" }}>
                                    Unit Rate
                                  </th>
                                  <th style={{ whiteSpace: "nowrap" }}>
                                    GST %
                                  </th>
                                  <th
                                    colSpan="4"
                                    style={{ whiteSpace: "nowrap" }}
                                  >
                                    Total Amount
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {filteredItems && filteredItems?.length > 0 ? (
                                  filteredItems?.map((row, index) => {
                                    if (!row?.item_id) {
                                      return (
                                        <tr>
                                          <td
                                            colSpan="10"
                                            style={{ textAlign: "center" }}
                                          >
                                            No data available.
                                          </td>
                                        </tr>
                                      );
                                    }
                                    return (
                                      <React.Fragment key={id}>
                                        <tr
                                          style={{
                                            borderBottom: "1px solid #cccccc",
                                            verticalAlign: "middle",
                                          }}
                                        >
                                          <td>{index + 1}</td>
                                          <td
                                            style={{
                                              paddingLeft: "10px",
                                              paddingRight: "2px",
                                              minWidth: "180px",
                                            }}
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              toggleRow(index);
                                            }}
                                          >
                                            <div
                                              style={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "5px", // Spacing between text and icon
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                                cursor:
                                                  row?.item?.type == 1 &&
                                                  "pointer",
                                              }}
                                              title={
                                                row?.item_details?.item_code ||
                                                "N/A"
                                              }
                                            >
                                              <span>
                                                {row?.item_details?.item_code ||
                                                  "N/A"}
                                              </span>

                                              {row?.item?.type === 1 && (
                                                <Link
                                                  className="text-primary"
                                                  onClick={(e) => {
                                                    e.stopPropagation();
                                                    toggleRow(index);
                                                  }}
                                                  style={{
                                                    cursor: "pointer",
                                                    display: "flex",
                                                    alignItems: "center",
                                                  }}
                                                >
                                                  <i
                                                    className={`mdi mdi-chevron-${
                                                      expandedRows[index]
                                                        ? "up"
                                                        : "down"
                                                    } font-size-18`}
                                                  ></i>
                                                </Link>
                                              )}
                                            </div>
                                          </td>

                                          <td
                                            style={{
                                              paddingLeft: "10px",
                                              paddingRight: "2px",
                                              minWidth: "180px",
                                            }}
                                          >
                                            <div
                                              style={{
                                                display: "-webkit-box",
                                                WebkitBoxOrient: "vertical",
                                                WebkitLineClamp: 2,
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "normal",
                                              }}
                                              title={
                                                row?.item_details?.item_desc ||
                                                "N/A"
                                              }
                                            >
                                              {row?.item_details?.item_desc ||
                                                "N/A"}
                                            </div>
                                          </td>

                                          <td
                                            style={{
                                              paddingLeft: "10px",
                                              paddingRight: "2px",
                                              minWidth: "180px",
                                            }}
                                          >
                                            <div
                                              style={{
                                                display: "-webkit-box",
                                                WebkitBoxOrient: "vertical",
                                                WebkitLineClamp: 2,
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "normal",
                                              }}
                                              title={
                                                row?.customer_desc || "N/A"
                                              }
                                            >
                                              {row?.customer_desc || "N/A"}
                                            </div>
                                          </td>
                                          <td
                                            style={{
                                              paddingLeft: "10px",
                                              paddingRight: "2px",
                                              minWidth: "100px",
                                            }}
                                          >
                                            {row?.item_details?.uom || "N/A"}
                                          </td>
                                          <td
                                            style={{
                                              paddingLeft: "10px",
                                              paddingRight: "2px",
                                              minWidth: "100px",
                                            }}
                                          >
                                            {formatNumber(row?.order_qty) || 0}
                                          </td>
                                          <td
                                            style={{
                                              paddingLeft: "10px",
                                              paddingRight: "2px",
                                              minWidth: "100px",
                                            }}
                                          >
                                            {formatNumber(row?.invoice_qty) ||
                                              0}
                                          </td>
                                          <td
                                            style={{
                                              paddingLeft: "10px",
                                              paddingRight: "2px",
                                              minWidth: "100px",
                                            }}
                                          >
                                            {formatNumber(row?.unit_rate) || 0}
                                          </td>
                                          <td
                                            style={{
                                              paddingLeft: "10px",
                                              paddingRight: "2px",
                                              minWidth: "80px",
                                            }}
                                          >
                                            {row?.gst_percentage || 0}
                                          </td>
                                          <td
                                            colSpan="4"
                                            style={{
                                              paddingLeft: "10px",
                                              paddingRight: "2px",
                                              minWidth: "110px",
                                            }}
                                          >
                                            {formatNumber(row?.amount) || 0}
                                          </td>
                                        </tr>
                                        {expandedRows[index] && (
                                          <>
                                            {/* Sub Item Header */}
                                            {row?.buy_item_details?.some(
                                              (child) =>
                                                child?.item?.item_code ||
                                                child?.item_code
                                            ) && (
                                              <>
                                                <tr
                                                  style={{
                                                    backgroundColor: "#d1ecf1",
                                                    fontWeight: "bold",
                                                  }}
                                                >
                                                  <td></td>
                                                  <td>Buy Item Code</td>
                                                  <td>Buy Item Description</td>
                                                  <td>UOM</td>
                                                  <td>BOM QTY</td>
                                                  <td colSpan="10"></td>
                                                </tr>
                                                {row?.buy_item_details
                                                  ?.filter(
                                                    (child) =>
                                                      child?.item?.item_code ||
                                                      child?.item_details
                                                        ?.item_code
                                                  )
                                                  ?.map((child, childIndex) => (
                                                    <tr
                                                      key={`${childIndex}-${childIndex}`}
                                                      style={{
                                                        backgroundColor: "",
                                                        borderBottom:
                                                          "1px solid #cccccc",
                                                      }}
                                                    >
                                                      <td></td>
                                                      <td
                                                        style={{
                                                          paddingLeft: "10px",
                                                          paddingRight: "2px",
                                                        }}
                                                      >
                                                        <div
                                                          style={{
                                                            display:
                                                              "-webkit-box",
                                                            WebkitBoxOrient:
                                                              "vertical",
                                                            WebkitLineClamp: 2,
                                                            overflow: "hidden",
                                                            textOverflow:
                                                              "ellipsis",
                                                            whiteSpace:
                                                              "normal",
                                                          }}
                                                          title={
                                                            child?.item_details
                                                              ?.item_code ||
                                                            child?.item_code ||
                                                            "N/A"
                                                          }
                                                        >
                                                          {child?.item_details
                                                            ?.item_code ||
                                                            child?.item_code ||
                                                            "N/A"}
                                                        </div>
                                                      </td>
                                                      <td
                                                        style={{
                                                          paddingLeft: "10px",
                                                          paddingRight: "2px",
                                                        }}
                                                      >
                                                        <div
                                                          style={{
                                                            display:
                                                              "-webkit-box",
                                                            WebkitBoxOrient:
                                                              "vertical",
                                                            WebkitLineClamp: 2,
                                                            overflow: "hidden",
                                                            textOverflow:
                                                              "ellipsis",
                                                            whiteSpace:
                                                              "normal",
                                                          }}
                                                          title={
                                                            child?.item_details
                                                              ?.item_desc ||
                                                            child?.item_desc ||
                                                            "N/A"
                                                          }
                                                        >
                                                          {child?.item_details
                                                            ?.item_desc ||
                                                            child?.item_desc ||
                                                            "N/A"}
                                                        </div>
                                                      </td>

                                                      <td
                                                        style={{
                                                          paddingLeft: "10px",
                                                          paddingRight: "2px",
                                                        }}
                                                      >
                                                        {child?.item_details
                                                          ?.uom ||
                                                          child?.uom ||
                                                          "N/A"}
                                                      </td>
                                                      <td
                                                        style={{
                                                          paddingLeft: "10px",
                                                          paddingRight: "2px",
                                                        }}
                                                      >
                                                        {formatNumber(
                                                          child?.qty
                                                        ) || 0}
                                                      </td>
                                                      <td colSpan="10"></td>
                                                    </tr>
                                                  ))}
                                              </>
                                            )}
                                          </>
                                        )}
                                      </React.Fragment>
                                    );
                                  })
                                ) : (
                                  <tr>
                                    <td
                                      colSpan="10"
                                      style={{ textAlign: "center" }}
                                    >
                                      No data available.
                                    </td>
                                  </tr>
                                )}

                                {totalQty >= 1 && (
                                  <tr
                                    style={{
                                      borderTop: "2px solid #cccccc",
                                      backgroundColor: "#d9d9d9",
                                      fontWeight: "bold",
                                      position: "sticky",
                                      bottom: 0,
                                      zIndex: 0,
                                    }}
                                  >
                                    <td></td>
                                    <td>Total</td>
                                    <td colSpan="3"></td>
                                    <td>{formatNumber(totalQty)}</td>
                                    <td>{formatNumber(totalInvoiceQty)}</td>
                                    <td>{formatNumber(totalUnitRate)}</td>
                                    <td></td>
                                    <td>{formatNumber(totalAmountData)}</td>
                                    <td colSpan="4"></td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <div
                          style={{
                            display: "none",
                            position: "absolute",
                            left: "-9999px",
                          }}
                          id="pdfContent"
                        >
                          <InvoicePDF data={formData.inputData} />
                        </div>
                      </Row>
                    </AvForm>
                    {/* Loader Overlay */}
                    {loadingData && (
                      <div style={loaderOverlay}>
                        <LoaderCreatePage />
                      </div>
                    )}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default InvoiceView;
